import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import Swal from 'sweetalert2';
import { FeeConfigService } from '../../fee-config.service';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
  selector: 'app-edit-fee',
  templateUrl: './edit-fee.component.html',
  styleUrls: ['./edit-fee.component.scss'],
  providers: [CurrencyPipe]
})
export class EditFeeComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  feeConfigForm: FormGroup;
  feeDatails: any;
  feeId: number;

  constructor(private activeRoute: ActivatedRoute, private fb: FormBuilder, private router: Router, private feeConfigService: FeeConfigService, public dialog: MatDialog) {
    super();
    this.feeId = this.activeRoute.snapshot.params.id;
    this.feeConfigForm = this.fb.group({
      paymentType: ['', [Validators.required]],
      feeType: ['', [Validators.required]],
      feeAmount: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
    })

  }


  ngOnInit(): void {
    this.feeConfigService.getAllFeeDetailsById(this.feeId).subscribe((res: any) => {
      this.feeDatails = res?.data;
      this.feeConfigForm.get('paymentType').setValue(this.feeDatails?.paymentType)
      this.feeConfigForm.get('feeType').setValue(this.feeDatails?.feeType)
      this.feeConfigForm.get('feeAmount').setValue(this.feeDatails?.feeValue)
      this.feeConfigForm.get('startDate').setValue(moment(this.feeDatails?.validityStartDttm, 'YYYY-MM-DD HH:mm:ss.S').toDate());
      this.feeConfigForm.get('endDate').setValue(moment(this.feeDatails?.validityEndDttm, 'YYYY-MM-DD HH:mm:ss.S').toDate());
    })

  }


  onSubmit() {
    if (this.feeConfigForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.feeConfigForm)
        } else {
          this.router.navigate([`features/consumers/fee-config/all-fee`])
        }
      });

    }
  }

  setSubmitParameters(feeConfigForm: FormGroup) {
    let httpParams: Params = {
      paymentType: feeConfigForm.get('paymentType').value,
      feeType: feeConfigForm.get('feeType').value,
      feeValue: feeConfigForm.get('feeAmount').value,
      id: this.feeId,
      validityStartDttm: moment(feeConfigForm.get('startDate').value).format('YYYY-MM-DD'),
      validityEndDttm: moment(feeConfigForm.get('endDate').value).format('YYYY-MM-DD'),
      // moment(feeConfigForm.get('startDate')).format('YYYY-MM-DD')
    }
    this.feeConfigService.updateFeeDetails(httpParams).subscribe(res => {
      if (res && res) {
        if (res.httpcode == 200 || res.responseStatus == 'Success') {
          this.router.navigate([`features/consumers/fee-config/all-fee`])
          this.toastrService.success('Fee Updated successfully', 'Success', {
            timeOut: 3000,
          });
        }
      }
    });
  }


  onCancel() {
    for (const name in this.feeConfigForm.controls) {
      if (this.feeConfigForm.controls[name].invalid) {

      } else {

      }
    }

    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.router.navigate([`features/consumers/fee-config/all-fee`])
      }
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}

